









































































































































































































































import { Component, Vue } from "vue-property-decorator";
import PublisAnnoucement from "@/components/PublishAnnoucement/table.vue";
import researchCenterService from "@/services/researchCenter.service";
import searcherService from "@/services/searcher.service";
import pdfvuer from "pdfvuer";
import ResearchCenter from "@/models/research/ResearchCenter/reseachCenter.model";
import UserService from "@/services/user.service";
import AnnoucementService from "@/services/Annoument.service";
import UrlForm from '@/models/urlForm.model';
import { PermissionValue } from '@/enums/PermissionValue';
import PermissionAccess from '@/models/security/permissionAccess.model';
import ProposalService from '@/services/porposal.service'
@Component({
  components: {
    publisannoucement: PublisAnnoucement
  }
})
export default class Home extends Vue {
  researchCenterService = new researchCenterService();
  searcherService = new searcherService();
  annoucementService = new AnnoucementService();

  userService: UserService = new UserService();
  proposalService: ProposalService = new ProposalService();
  
  filter = "";
  model: any;
  name = "";
  isActive = false;
  userName = "";
  userLastName = "";
  userRequested = {};
  centerName = "";
  si = true;
  loading = false;
  currentTab = 1;
  researchCenters: [];
  autoCompleteResearchCenters: Array<string> = [];
  records: [];
  isImageModalActive: Boolean;
  responseLanguage = "";
  responseExperience = "";
  annoucementPublishes = [];
  pdfdata: any = null;
  numPages: number = 0;
  currentUrl: UrlForm = null;
  loadingInstitutions = true;
  permissionValue: PermissionValue = PermissionValue.INICIO;
  permissionAccess: PermissionAccess | any = {};

  get isMobile() {
    return this.$store.state.isMobile;
  }
  constructor() {
    super();
    this.researchCenters = [];
    this.isImageModalActive = false;
    this.records = [];
    this.model = new ResearchCenter();
  }
  created() {
    this.permissionValue = PermissionValue.CUESTIONARIOONLINEVIEW;
    this.permissionAccess = this.userService.getPermissionAccessLevel(
      this.permissionValue
    );

    this.getResearchCenter();
    this.getAllPublished();
  }

  isImageModalActive1() {
    this.isImageModalActive = true;
  }
  goToAnnoucementDetail(id: number) {
    this.$router.push(`convocatoria/detail/${id}`);
  }
  public getAllPublished() {
    this.loading = true;
    this.annoucementService
      .getPublish()
      .then(response => {
        this.annoucementPublishes = response;
      })
      .finally(() => {
        this.loading = false;
      });
  }

  public searcher(event: any) {
    if (event.keyCode === 13 || !this.name) {
      this.loadingInstitutions = true;
      if (this.name) {
        this.researchCenterService
          .searchByName(this.name.toLowerCase())
          .then(response => {
            this.researchCenters = response;
          })
          .finally(() => {
            this.loadingInstitutions = false;
          });
      } else {
        this.researchCenterService
          .getResearch()
          .then(response => {
            this.researchCenters = response;
          })
          .finally(() => {
            this.loadingInstitutions = false;
          });
      }
    }
  }
  get user() {
    return this.$store.state.user;
  }

  goToUrl() {
    window.open(this.currentUrl.url, "_blank")
  }

  async updateCreatedBy() {
    await this.proposalService.UpdateCreatedByProporsal();
  }

  async mounted() {
    this.getUser();
    this.currentUrl = await this.searcherService.getActiveForm();
    var self = this;
    self.pdfdata = pdfvuer.createLoadingTask("/pdf/reglamento.pdf");
    self.pdfdata.then((pdf: any) => {
      self.numPages = pdf.numPages;
    });
  }

  getUser() {
    if (!this.user.disabled) {
      let promise;
      this.userService.getUserById(this.user.id).then(user => {
        this.userRequested = user;
         promise = user;
        this.userName = user.name;
        this.userLastName = user.lastName;
        promise.userLanguages.forEach(x => {
          this.responseLanguage += x.language;
        });
        debugger;
        if (!this.responseLanguage && !promise.dontShowCreateResumeAgain) {
          this.$buefy.dialog.confirm({
            title: "Debe crear su Curriculum",
            message:
              "Hola " +
              ` <b>${this.userName}` +
              " " +
              `${this.userLastName}</b>` +
              " Antes de continuar  ¿le gustaría crear su currículum ?",
            confirmText: "Crear",
            cancelText: "No volver a mostrar",
            type: "is-warning",
            hasIcon: true,
            size: "is-medium",
            onConfirm: () => {
              this.$router.push(`/profile/addCurriculum`);
            },
            onCancel:() =>{
              debugger;
              this.userService.dontShowCreateResumeUserAgain(this.user.id);
            }
          });
        }
      });
    }
  }
  public getResearchCenter() {
    this.loadingInstitutions = true;
    this.researchCenterService
      .getResearch()
      .then(response => {
        this.autoCompleteResearchCenters = [];
        response.forEach((x: ResearchCenter) => {
          this.autoCompleteResearchCenters.push(x.name as any);
          this.autoCompleteResearchCenters.push(x.abbreviation as any);
        });
        this.researchCenters = response;
      })
      .finally(() => {
        this.loadingInstitutions = false;
      });
  }
  get filteredDataObj() {
    return this.autoCompleteResearchCenters.filter((option: any) => {
      return (
        option
          .toString()
          .toLowerCase()
          .indexOf(this.name.toLowerCase()) >= 0
      );
    });
  }

  getImage(image: any) {
    if (image) return `data:image/jpg;base64, ${image}`;
  }
}
